// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SurveyModal_surveyModal__Y7Yzp {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  z-index: 99;
}
.SurveyModal_surveyModal__Y7Yzp > div {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
}
.SurveyModal_surveyModal__Y7Yzp > span > div {
  z-index: 2000 !important;
}

.SurveyModal_surveyMiddle__Fpijm {
  position: absolute;
  background: var(--background-quaternary);
  z-index: 3500;
  border-radius: 5px;
  padding: 15px;
  min-width: 300px;
}

.SurveyModal_surveyHeader__3PpEp svg {
  width: 16px;
  height: 16px;
}
.SurveyModal_surveyHeader__3PpEp path {
  stroke: var(--text-primary);
}
.SurveyModal_surveyHeader__3PpEp h4 {
  color: var(--text-primary);
  font-size: 0.95em;
}
.SurveyModal_surveyHeader__3PpEp > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.SurveyModal_surveyBody__5DuF5 {
  padding: 10px;
}
.SurveyModal_surveyBody__5DuF5 .SurveyModal_cardProfile__sps36 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.SurveyModal_surveyBody__5DuF5 .SurveyModal_cardProfile_circle__P3LL- {
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 70px;
  background: var(--accent-blue-primary);
  border-radius: 999px;
}
.SurveyModal_surveyBody__5DuF5 .SurveyModal_cardProfile_circle__P3LL- span {
  color: var(--text-on-color);
  border-radius: 999px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 50.52%);
  font-size: 1.2em;
}
.SurveyModal_surveyBody__5DuF5 .SurveyModal_cardProfile__sps36 > h4 {
  margin-top: 15px;
  color: var(--text-primary);
}
.SurveyModal_surveyBody__5DuF5 .SurveyModal_cardProfile__sps36 > p {
  margin-top: 3px;
  color: var(--text-secondary);
  font-size: 0.9em;
}

.SurveyModal_surveyMain__rt5f6 {
  margin-top: 25px;
}
.SurveyModal_surveyMain__rt5f6 > p {
  color: var(--text-secondary);
  font-size: 0.9em;
}

.SurveyModal_surveyStars__Xpr7S {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row-reverse;
  margin-top: 3px;
}
.SurveyModal_surveyStars__Xpr7S svg {
  width: 18px;
  height: 18px;
}
.SurveyModal_surveyStars__Xpr7S button:hover path, .SurveyModal_surveyStars__Xpr7S button:hover ~ button path {
  stroke: gold;
  fill: gold;
}

.SurveyModal_issues__galdx {
  display: flex;
  gap: 40px;
  margin-top: 20px;
}

.SurveyModal_issuesSec__5XyAr {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.SurveyModal_issuesSec__5XyAr > h5 {
  color: var(--text-primary);
  margin-bottom: 5px;
}
.SurveyModal_issuesSec__5XyAr > div {
  display: flex;
  align-items: center;
  gap: 10px;
}
.SurveyModal_issuesSec__5XyAr input {
  border: 1px solid var(--border-secondary);
}
.SurveyModal_issuesSec__5XyAr label {
  color: var(--text-secondary);
  font-size: 0.9em;
}

.SurveyModal_additional__8oJAa {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
}
.SurveyModal_additional__8oJAa textarea {
  border: 1px solid var(--border-primary);
  border-radius: 5px;
  padding: 13px 16px;
  min-height: 100px;
}
.SurveyModal_additional__8oJAa a {
  margin-top: 20px;
  font-size: 0.9em;
  color: var(--default-primary);
}

.SurveyModal_btn__0uWt5 {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
}
.SurveyModal_btn__0uWt5 button {
  padding: 7px 17px;
  background: var(--background-emphasis);
  color: var(--text-primary);
  border-radius: 5px;
  border: 1px solid var(--border-primary);
}

.SurveyModal_submit__6yW7c {
  padding: 7px 15px;
  background: var(--default-primary) !important;
  color: white !important;
  border: 1px solid var(--default-primary) !important;
}

.SurveyModal_surveyCompleted__of\\+HF {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
}
.SurveyModal_surveyCompleted__of\\+HF h3 {
  color: var(--text-primary);
  font-size: 1.05em;
  margin-top: 10px;
}
.SurveyModal_surveyCompleted__of\\+HF p {
  color: var(--text-secondary);
  font-size: 0.85em;
  margin-top: 5px;
}

.SurveyModal_surveyCheck__dVC6g svg {
  width: 90px;
  height: 90px;
}
.SurveyModal_surveyCheck__dVC6g svg path {
  fill: var(--primary-rpm-default);
}

.SurveyModal_surveyTimer__TPHYx {
  font-size: 0.7em !important;
  color: var(--text-secondary);
  margin-top: 5px;
}

@media only screen and (max-width: 410px) {
  .SurveyModal_surveyMiddle__Fpijm {
    width: 90% !important;
    min-width: 90% !important;
  }
}
@media only screen and (max-width: 260px) {
  .SurveyModal_btn__0uWt5 {
    flex-direction: column;
  }
  .SurveyModal_btn__0uWt5 button {
    width: 100%;
  }
}
@media only screen and (max-width: 350px) {
  .SurveyModal_issues__galdx {
    flex-direction: column;
  }
}
@media only screen and (max-height: 860px) {
  .SurveyModal_surveyMiddle__Fpijm {
    height: 75%;
    overflow: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SurveyModal/SurveyModal.module.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AACD;AACC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACF;AAGE;EACC,wBAAA;AADH;;AAMA;EACC,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAHD;;AAOC;EACC,WAAA;EACA,YAAA;AAJF;AAOC;EACC,2BAAA;AALF;AAQC;EAEC,0BAAA;EACA,iBAAA;AAPF;AAUC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AARF;;AAYA;EACC,aAAA;AATD;AAWC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AATF;AAWE;EACC,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,oBAAA;AATH;AAWG;EACC,2BAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+FAAA;EACA,gBAAA;AATJ;AAaE;EACC,gBAAA;EACA,0BAAA;AAXH;AAcE;EACC,eAAA;EACA,4BAAA;EACA,gBAAA;AAZH;;AAiBA;EACC,gBAAA;AAdD;AAgBC;EACC,4BAAA;EACA,gBAAA;AAdF;;AAkBA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,2BAAA;EACA,eAAA;AAfD;AAiBC;EACC,WAAA;EACA,YAAA;AAfF;AAqBG;EACC,YAAA;EACA,UAAA;AAnBJ;;AAyBA;EACC,aAAA;EACA,SAAA;EACA,gBAAA;AAtBD;;AAyBA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AAtBD;AAwBC;EACC,0BAAA;EACA,kBAAA;AAtBF;AAyBC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAvBF;AA0BC;EACC,yCAAA;AAxBF;AA2BC;EACC,4BAAA;EACA,gBAAA;AAzBF;;AA6BA;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;AA1BD;AA4BC;EACC,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AA1BF;AA6BC;EACC,gBAAA;EACA,gBAAA;EACA,6BAAA;AA3BF;;AA+BA;EACC,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AA5BD;AA8BC;EACC,iBAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,uCAAA;AA5BF;;AAgCA;EACC,iBAAA;EACA,6CAAA;EACA,uBAAA;EACA,mDAAA;AA7BD;;AAgCA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AA7BD;AA+BC;EACC,0BAAA;EACA,iBAAA;EACA,gBAAA;AA7BF;AAgCC;EACC,4BAAA;EACA,iBAAA;EACA,eAAA;AA9BF;;AAmCC;EACC,WAAA;EACA,YAAA;AAhCF;AAkCE;EACC,gCAAA;AAhCH;;AAqCA;EACC,2BAAA;EACA,4BAAA;EACA,eAAA;AAlCD;;AAqCA;EACC;IACC,qBAAA;IACA,yBAAA;EAlCA;AACF;AAqCA;EACC;IACC,sBAAA;EAnCA;EAqCA;IACC,WAAA;EAnCD;AACF;AAuCA;EACC;IACC,sBAAA;EArCA;AACF;AAwCA;EACC;IACC,WAAA;IACA,cAAA;EAtCA;AACF","sourcesContent":[".surveyModal {\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 100vh;\n\twidth: 100vw;\n\tz-index: 99;\n\n\t> div {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n\n\t> span {\n\t\t> div {\n\t\t\tz-index: 2000 !important;\n\t\t}\n\t}\n}\n\n.surveyMiddle {\n\tposition: absolute;\n\tbackground: var(--background-quaternary);\n\tz-index: 3500;\n\tborder-radius: 5px;\n\tpadding: 15px;\n\tmin-width: 300px;\n}\n\n.surveyHeader {\n\tsvg {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t}\n\n\tpath {\n\t\tstroke: var(--text-primary);\n\t}\n\n\th4 {\n\t\t// color: var(--text-primary);\n\t\tcolor: var(--text-primary);\n\t\tfont-size: 0.95em;\n\t}\n\n\t> div {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t}\n}\n\n.surveyBody {\n\tpadding: 10px;\n\n\t.cardProfile {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tmargin-top: 20px;\n\n\t\t&_circle {\n\t\t\tmargin-right: 8px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\twidth: 70px;\n\t\t\theight: 70px;\n\t\t\tbackground: var(--accent-blue-primary);\n\t\t\tborder-radius: 999px;\n\n\t\t\t& span {\n\t\t\t\tcolor: var(--text-on-color);\n\t\t\t\tborder-radius: 999px;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\tbackground: linear-gradient(135deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 50.52%);\n\t\t\t\tfont-size: 1.2em;\n\t\t\t}\n\t\t}\n\n\t\t> h4 {\n\t\t\tmargin-top: 15px;\n\t\t\tcolor: var(--text-primary);\n\t\t}\n\n\t\t> p {\n\t\t\tmargin-top: 3px;\n\t\t\tcolor: var(--text-secondary);\n\t\t\tfont-size: 0.9em;\n\t\t}\n\t}\n}\n\n.surveyMain {\n\tmargin-top: 25px;\n\n\t> p {\n\t\tcolor: var(--text-secondary);\n\t\tfont-size: 0.9em;\n\t}\n}\n\n.surveyStars {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tflex-direction: row-reverse;\n\tmargin-top: 3px;\n\n\tsvg {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t}\n\n\tbutton {\n\t\t&:hover,\n\t\t&:hover ~ button {\n\t\t\tpath {\n\t\t\t\tstroke: gold;\n\t\t\t\tfill: gold;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.issues {\n\tdisplay: flex;\n\tgap: 40px;\n\tmargin-top: 20px;\n}\n\n.issuesSec {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 5px;\n\n\t> h5 {\n\t\tcolor: var(--text-primary);\n\t\tmargin-bottom: 5px;\n\t}\n\n\t> div {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t}\n\n\tinput {\n\t\tborder: 1px solid var(--border-secondary);\n\t}\n\n\tlabel {\n\t\tcolor: var(--text-secondary);\n\t\tfont-size: 0.9em;\n\t}\n}\n\n.additional {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-top: 30px;\n\n\ttextarea {\n\t\tborder: 1px solid var(--border-primary);\n\t\tborder-radius: 5px;\n\t\tpadding: 13px 16px;\n\t\tmin-height: 100px;\n\t}\n\n\ta {\n\t\tmargin-top: 20px;\n\t\tfont-size: 0.9em;\n\t\tcolor: var(--default-primary);\n\t}\n}\n\n.btn {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: flex-end;\n\tgap: 10px;\n\tmargin-top: 15px;\n\n\tbutton {\n\t\tpadding: 7px 17px;\n\t\tbackground: var(--background-emphasis);\n\t\tcolor: var(--text-primary);\n\t\tborder-radius: 5px;\n\t\tborder: 1px solid var(--border-primary);\n\t}\n}\n\n.submit {\n\tpadding: 7px 15px;\n\tbackground: var(--default-primary) !important;\n\tcolor: white !important;\n\tborder: 1px solid var(--default-primary) !important;\n}\n\n.surveyCompleted {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tpadding: 40px 20px;\n\n\th3 {\n\t\tcolor: var(--text-primary);\n\t\tfont-size: 1.05em;\n\t\tmargin-top: 10px;\n\t}\n\n\tp {\n\t\tcolor: var(--text-secondary);\n\t\tfont-size: 0.85em;\n\t\tmargin-top: 5px;\n\t}\n}\n\n.surveyCheck {\n\tsvg {\n\t\twidth: 90px;\n\t\theight: 90px;\n\n\t\tpath {\n\t\t\tfill: var(--primary-rpm-default);\n\t\t}\n\t}\n}\n\n.surveyTimer {\n\tfont-size: 0.7em !important;\n\tcolor: var(--text-secondary);\n\tmargin-top: 5px;\n}\n\n@media only screen and (max-width: 410px) {\n\t.surveyMiddle {\n\t\twidth: 90% !important;\n\t\tmin-width: 90% !important;\n\t}\n}\n\n@media only screen and (max-width: 260px) {\n\t.btn {\n\t\tflex-direction: column;\n\n\t\tbutton {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n\n@media only screen and (max-width: 350px) {\n\t.issues {\n\t\tflex-direction: column;\n\t}\n}\n\n@media only screen and (max-height: 860px) {\n\t.surveyMiddle {\n\t\theight: 75%;\n\t\toverflow: auto;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"surveyModal": `SurveyModal_surveyModal__Y7Yzp`,
	"surveyMiddle": `SurveyModal_surveyMiddle__Fpijm`,
	"surveyHeader": `SurveyModal_surveyHeader__3PpEp`,
	"surveyBody": `SurveyModal_surveyBody__5DuF5`,
	"cardProfile": `SurveyModal_cardProfile__sps36`,
	"cardProfile_circle": `SurveyModal_cardProfile_circle__P3LL-`,
	"surveyMain": `SurveyModal_surveyMain__rt5f6`,
	"surveyStars": `SurveyModal_surveyStars__Xpr7S`,
	"issues": `SurveyModal_issues__galdx`,
	"issuesSec": `SurveyModal_issuesSec__5XyAr`,
	"additional": `SurveyModal_additional__8oJAa`,
	"btn": `SurveyModal_btn__0uWt5`,
	"submit": `SurveyModal_submit__6yW7c`,
	"surveyCompleted": `SurveyModal_surveyCompleted__of+HF`,
	"surveyCheck": `SurveyModal_surveyCheck__dVC6g`,
	"surveyTimer": `SurveyModal_surveyTimer__TPHYx`
};
export default ___CSS_LOADER_EXPORT___;
